// @flow
/* eslint-env browser */
import { tracker } from 'angieslist-app-platform';
import { get } from 'lodash';
import { getCid } from '../../../app/browser/analyticsHelpers';

const trackAdvertiseRequestSent =
  (isSuccessful: boolean, meta: Object, store: Object) => {
    const { activityLocation, categorySegmentData, description } = meta;
    const descriptionEvent = description || 'Generic CTA';
    tracker.track('Advertising Request Sent', {
      userId: get(store.getState(), 'user.userInfo.response.userId', ''),
      isSuccessful,
      description: descriptionEvent,
      activityLocation,
      userType: 'Authenticated',
      cid: getCid(),
      pathName: typeof window !== 'undefined' ? window.location.pathname : null,
      serviceProviderId: store.getState().serviceProviderId || undefined,
      ...categorySegmentData,
    });
  };

export default {
  trackAdvertiseRequestSent,
};



// WEBPACK FOOTER //
// ./src/app/common/advertise/advertiseUtils.js